var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.125 15.9619L18 20.4619L19.875 15.9619",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 19.9463C7.14117 20.2743 6.67366 20.458 6.1875 20.4619C5.04375 20.4619 4.125 19.4588 4.125 18.2119C4.125 16.965 5.04375 15.9619 6.1875 15.9619C6.67366 15.9658 7.14117 16.1495 7.5 16.4775",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 20.0869C10.9063 20.39 11.3994 20.5543 11.9062 20.5557C12.75 20.5557 13.5 20.2744 13.5 19.3369C13.5 17.8369 10.5 18.4932 10.5 17.0869C10.5 16.3369 11.0625 15.8682 11.9062 15.8682C12.4131 15.8695 12.9062 16.0338 13.3125 16.3369",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 12.2119V3.96191C4.5 3.763 4.57902 3.57224 4.71967 3.43158C4.86032 3.29093 5.05109 3.21191 5.25 3.21191H14.25L19.5 8.46191V12.2119",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 3.21191V8.46191H19.5",
    stroke: "#4D4E50",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsv);
export default __webpack_public_path__ + "static/media/csv.d61614998c76f0497fe387da6b260713.svg";
export { ForwardRef as ReactComponent };